import searchForWealthImg from 'assets/images/searchForWealth.jpg';
import searchForWealthOverview from 'assets/images/booksOverview/searchForWealth.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const searchForWealth = {
  book: {
    id: 'saq-suche-nach-reichtum',
    format: FLIP_BOOKS,
    title: 'In search of wealth2',
    subtitle: 'Premium only',
    videos: 'Erwin W. Heri, Andreas Homberger and Andreas Löpfe',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 52, videos: 48 },
    price: [40],
    introductions: ['Introduction in search for wealth'],
    image: searchForWealthImg,
    overviewImg: searchForWealthOverview,
  },
  bookIds: [41, 46],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([40, 40], [41, 41, 46], 100),
};

export default searchForWealth;
